import {createFileRoute} from '@tanstack/react-router';

import {AdvanceProofWindowPage} from '@/modules/admin-settings/pages/AdvanceProofWindowPage';

export const Route = createFileRoute('/_authenticated/admin/settings/receipt-window/')({
  component: AdvanceProofWindowPage,
});
